/**
 * Operation Sherman feature flags.
 *
 * Per Stephen 2026-05-19 the rollout uses environment variables (not a
 * database flag table) for v0.1 \u2014 simple, no schema, no admin UI to
 * build. Server-side checks read the unprefixed var; client-side checks
 * read NEXT_PUBLIC_*.
 *
 * Convention:
 *   - Server: read process.env.SHERMAN_CHAT_THREADS_V2
 *   - Client: import from '@/lib/connectors/flags' which reads
 *     NEXT_PUBLIC_SHERMAN_CHAT_THREADS_V2 via Next.js inlined env
 *
 * Promotion path: once a flag has been on in prod for a week without
 * regressions, delete the flag check and the old code path it gates.
 *
 * Spec: ~/.openclaw/workspace/specs/operation-sherman-spec.md \u00a74, \u00a714
 */

function readBool(value: string | undefined): boolean {
  if (!value) return false
  return value === '1' || value.toLowerCase() === 'true'
}

/**
 * Cursor-style thread sidebar + thread-only message hydration (kill the
 * single infinite chat). Default off until merged + verified in dev.
 *
 * Reads:
 *   - server: SHERMAN_CHAT_THREADS_V2
 *   - client: NEXT_PUBLIC_SHERMAN_CHAT_THREADS_V2
 *
 * The client-side var is the canonical source for UI behavior. Server
 * code that wants to know should also check the same var (set both in
 * Vercel env config to keep them in lockstep).
 */
export function isChatThreadsV2Enabled(): boolean {
  // NEXT_PUBLIC_* is inlined at build time and available on both server
  // and client. Prefer it for consistency.
  if (typeof process !== 'undefined') {
    if (readBool(process.env.NEXT_PUBLIC_SHERMAN_CHAT_THREADS_V2)) return true
    if (readBool(process.env.SHERMAN_CHAT_THREADS_V2)) return true
  }
  return false
}
